export default __webpack_public_path__ + "static/media/img1.2d79bdfa.jpg";